import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
// import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import firestore from '../firebase';
import ScrollToTop from './ScrollToTop';
import Home from './Home/Home';
import DraftStake from './ViewStake/DraftStake';
import ConfirmEditStake from './ViewStake/ConfirmEditStake';
import ViewStakeContainer from './ViewStake/ViewStakeContainer';

import { fetchUsers, setMyStakes, setChallengedStakes } from './rootReducer';

import './App.css';

const testStake = {
  stakerId: 'auth0|5a9bf59d2610e30284e22124',
  stakee: 'auth0|5aad1c71aa9ad130c174a0bb',
  stakeeProfile: {
    name: 'zac',
    avatar:
      'https://s.gravatar.com/avatar/e6b6f0170838b77bc4706aed61c95aa3?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fza.png'
  },
  rules: 'Standard pro rules. Normal rackets and elliot must play left handed',
  odds: 2,
  amount: 500,
  currency: 'STAKE',
  title: 'Table Tennis',
  winCriteria: 'Best of 3 win',
  loseCriteria: 'Best of 2 lost',
  lastUpdated: 1522961828819,
  status: 'Draft'
};

// {
//   <TransitionGroup>
// <CSSTransition key={location.key} classNames="fade" timeout={500}>
// </CSSTransition>
// </TransitionGroup>
// }

// fn's that when called will unsubscribe/detach the firebase listener
let listeners = [];

class App extends Component {
  componentWillMount() {
    // TODO move to constructor?
    this.props.fetchUsers();
  }

  componentDidMount() {
    const uid = this.props.userProfile.sub; //"auth0|5a9bf59d2610e30284e22124"
    const myStakesQuery = firestore.collection('stakes').where('stakerId', '==', uid); //.orderBy('lastUpdated', 'desc');
    const challengedStakesQuery = firestore.collection('stakes').where('stakee', '==', uid);

    const observer = (setStakesAction, isMyStake) => ({
      next: querySnapshot => {
        const stakes = querySnapshot.docs.map(x => ({ id: x.id, ...x.data(), isMyStake }));
        setStakesAction(stakes);
      },
      error: err => console.log(`Error retrieving your stakes, listener stopped: ${err}`)
    });

    listeners.push(myStakesQuery.onSnapshot(observer(this.props.setMyStakes, true)));
    listeners.push(challengedStakesQuery.onSnapshot(observer(this.props.setChallengedStakes)));
  }

  componentWillUnmount() {
    console.log('unmounting <App />');
    listeners.forEach(x => x());
  }

  render() {
    return (
      <ScrollToTop>
        <Container as="main" id="app" className="margin">
          <Route path="/" exact render={props => <Home {...this.props} />} />
          <Route path="/confirmEdit" component={ConfirmEditStake} />
          <Route path="/confirm-draft" render={props => <DraftStake {...this.props} />} />
          <Route path="/stakes/:stakeId" component={ViewStakeContainer} test={testStake} />
        </Container>
      </ScrollToTop>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  userProfile: auth.profile
});
export default connect(mapStateToProps, { fetchUsers, setMyStakes, setChallengedStakes })(App);



// WEBPACK FOOTER //
// ./src/App/App.js